import { FeaturePlanEditView } from './feature-plan-edit';
import { PlanEditProvider } from './plan-edit.provider';

export const FeaturePlanEdit = () => {
   return (
      <PlanEditProvider>
         <FeaturePlanEditView />
      </PlanEditProvider>
   );
};
